import { Menu, MenuProps } from 'antd';
import { useCallback, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IRouteConfig } from '../../../interfaces/routeConfig';
import { Authorization } from '../../../shared';
import { useCurrentRoute } from '../../../hooks';
import { LogoComponent } from './LogoComponent';
import { ContextApp } from '../../../contexts/ContextApp';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { NavContext } from '@ionic/react';
import { FeatureFlag } from '../../../shared/FeatureFlag';
import './index.less';

export const MainMenu = ({ routes }: { routes: IRouteConfig[] }) => {
  const {
    functions,
    mainMenuCollapsed,
    selectedTenantId,
    featureFlags,
    openKeys,
    setOpenKeys,
  } = useContext(ContextApp);
  const { navigate } = useContext(NavContext);
  const { leafRoute, matchedRoutes } = useCurrentRoute();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  useEffect(() => {
    if (leafRoute) {
      if (!selectedTenantId && leafRoute.requiresTenantSelected)
        navigate('/app/selectTenant');
      setSelectedKeys([leafRoute.key]);
    } else {
      setSelectedKeys([]);
    }

    const matchedNotLeafRoutes = matchedRoutes.filter(
      (item) => !!item.routes?.length,
    );
    if (matchedNotLeafRoutes.length && !mainMenuCollapsed) {
      const routesKeys = matchedNotLeafRoutes.map((item) => item.key);
      setOpenKeys((oldOpenKeys) => {
        const keys = new Set(oldOpenKeys);
        for (const routesKey of routesKeys) {
          keys.add(routesKey);
        }
        return Array.from(keys);
      });
    }
  }, [leafRoute?.key, mainMenuCollapsed]);

  useEffect(() => {
    if (mainMenuCollapsed) {
      setOpenKeys([]);
    }
  }, [mainMenuCollapsed]);

  const menuProps: MenuProps = {
    theme: 'dark',
    mode: 'inline',
  };

  const renderMenuRoutes = useCallback(
    (paramRoutes: IRouteConfig[]): ItemType[] => {
      return paramRoutes
        .filter(
          (item) =>
            !(
              (item.authority &&
                !Authorization.security(functions, item.authority)) ||
              (item.featureFlag &&
                FeatureFlag.hideInMenu(featureFlags, item.featureFlag)) ||
              item.hideInMenu
            ),
        )
        .reduce<ItemType[]>((acc, item) => {
          if (item.routes) {
            acc.push({
              children: renderMenuRoutes(item.routes),
              key: item.key,
              icon: item.icon,
              label: item.name,
              className: item.className,
            });
          } else {
            acc.push({
              key: item.key,
              label: <Link to={item.path}>{item.name}</Link>,
              icon: item.icon,
              className: item.className,
            });
          }

          return acc;
        }, []);
    },
    [functions, featureFlags],
  );

  return (
    <>
      <LogoComponent />
      <Menu
        className="MainMenu"
        {...menuProps}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        items={renderMenuRoutes(routes)}
      />
    </>
  );
};
